import React from 'react';

import { Logo } from '@components/Logo';

import { COLORS } from '@constants/colors';
import { CONTACT_INFO } from '@constants/contact';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="mt-auto relative"
      style={{ backgroundColor: COLORS.secondary, color: 'white' }}
    >
      <div className="px-4 sm:px-6 py-8 sm:py-12 max-w-6xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-4 -ml-[20px]">
              <Logo width={120} height={42} fill="white" />
            </div>
            <p className="text-sm leading-relaxed mb-4">
              AMFI certified mutual fund distributor helping clients invest the
              right way.
            </p>
            <p className="text-xs opacity-80">
              <strong>AMFI ARN:</strong> {CONTACT_INFO.amfi.arn}
            </p>
            <p className="text-xs opacity-80">
              <strong>Distributor name:</strong>{' '}
              {CONTACT_INFO.contact_person.full_name}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-base">Quick links</h4>
            <div className="space-y-2">
              <a
                href="/services"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Services
              </a>
              <a
                href="/about"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                About
              </a>
              <a
                href="/contact"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Contact
              </a>
              <a
                href="/guides"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Investment guides
              </a>
              <a
                href="/tools"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Financial tools & calculators
              </a>
              <a
                href="/privacy-policy"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Privacy policy
              </a>
              <a
                href="/terms-conditions"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Terms & conditions
              </a>
            </div>
          </div>

          {/* Financial Tools */}
          <div>
            <h4 className="font-semibold mb-4 text-base">Calculators</h4>
            <div className="space-y-2">
              <a
                href="/tools/goal-planner"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Goal planner
              </a>
              <a
                href="/tools/retirement-planner"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Retirement planner
              </a>
              <a
                href="/tools/risk-profiler"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Risk profiler
              </a>
              <a
                href="/tools/sip-calculator"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                SIP calculator
              </a>
              <a
                href="/tools/swp-calculator"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                SWP calculator
              </a>
              <a
                href="/tools/lumpsum-calculator"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Lumpsum calculator
              </a>
              <a
                href="/tools/tax-calculator"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Tax calculator
              </a>
              <a
                href="/tools/home-loan-calculator"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Home loan calculator
              </a>
              <a
                href="/tools/profit-loss-calculator"
                className="block text-sm text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
              >
                Profit/loss calculator
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-base">Contact</h4>
            <div className="space-y-2">
              <p className="text-sm">
                <a
                  href={`mailto:${CONTACT_INFO.email.general}?subject=Investment Inquiry`}
                  className="text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
                >
                  {CONTACT_INFO.email.general}
                </a>
              </p>
              <p className="text-sm">
                <a
                  href={`tel:${CONTACT_INFO.phone.primary}`}
                  className="text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
                >
                  {CONTACT_INFO.phone.display}
                </a>
              </p>
              <p className="text-sm">
                <a
                  href={CONTACT_INFO.address.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/90 underline decoration-white/40 underline-offset-2 hover:text-white hover:decoration-white/80 transition-all duration-200"
                >
                  {CONTACT_INFO.address.short}
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 pt-6 border-t border-white/10 text-center">
          <p className="text-sm opacity-70 leading-relaxed max-w-4xl mx-auto">
            <strong>Disclaimer</strong>: Mutual fund investments are subject to
            market risks. Please read all scheme-related documents carefully
            before investing.
          </p>
        </div>
      </div>

      <div
        className="text-center py-3 sm:py-4 text-xs sm:text-sm px-4"
        style={{ backgroundColor: 'rgba(0,0,0,0.12)' }}
      >
        © {currentYear} {CONTACT_INFO.company.name}. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
